export enum TeamReviewDecision {
    NotYetStarted = 0,
    InProgress = 1,
    Approved = 2,
    Denied = 3,
    WaitingForUserSubmission = 4
}